var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":_vm.logout}},[_c('i',{staticClass:"nc-icon nc-button-power"}),_c('span',{staticClass:"d-lg-none"},[_vm._v("CERRAR SESIÓN")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }